function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import deepEqual from 'fast-deep-equal';
import memoize from 'memoizee';
import { LayoutUtils } from '@deephaven/dashboard';
import { DateTimeColumnFormatter, Formatter, FormatterUtils, TableUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import { getActiveTool, getApi, getSettings } from '@deephaven/redux';
import { assertNotNull, EMPTY_ARRAY, Pending, PromiseUtils } from '@deephaven/utils';
import DropdownFilter from "../controls/dropdown-filter/DropdownFilter.js";
import { getColumnsForDashboard, getColumnSelectionValidatorForDashboard, getIsolatedLinkerPanelIdForDashboard, getLinksForDashboard, getTableMapForDashboard } from "../redux/index.js";
import "./DropdownFilterPanel.css";
import ToolType from "../linker/ToolType.js";
import WidgetPanel from "./WidgetPanel.js";
import { emitFilterChanged } from "../FilterEvents.js";
import { emitLinkPointSelected } from "../linker/LinkerEvent.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('DropdownFilterPanel');
var DROPDOWN_FILTER_DEBOUNCE = 250;
var WIDGET_DESCRIPTOR = Object.freeze({
  name: 'Dropdown Filter',
  type: 'DropdownFilter'
});
var mapStateToProps = (state, ownProps) => {
  var localDashboardId = ownProps.localDashboardId;
  var panelId = LayoutUtils.getIdFromPanel({
    props: ownProps
  });
  var panelTableMap = getTableMapForDashboard(state, localDashboardId);
  var dashboardLinks = getLinksForDashboard(state, localDashboardId);
  var activeTool = getActiveTool(state);
  var isolatedLinkerPanelId = getIsolatedLinkerPanelIdForDashboard(state, localDashboardId);
  var isLinkerActive = activeTool === ToolType.LINKER && (isolatedLinkerPanelId === undefined || isolatedLinkerPanelId === panelId);
  // Disable linking if linker is in isolated mode for a different panel
  var disableLinking = activeTool === ToolType.LINKER && isolatedLinkerPanelId !== undefined && isolatedLinkerPanelId !== panelId;
  return {
    columns: getColumnsForDashboard(state, localDashboardId),
    columnSelectionValidator: getColumnSelectionValidatorForDashboard(state, localDashboardId),
    dh: getApi(state),
    isLinkerActive,
    disableLinking,
    settings: getSettings(state),
    panelTableMap,
    dashboardLinks
  };
};
var connector = connect(mapStateToProps, null, null, {
  forwardRef: true
});
export class DropdownFilterPanel extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "dateTimeFormatter", void 0);
    _defineProperty(this, "dropdownFilterRef", void 0);
    _defineProperty(this, "panelContainer", void 0);
    _defineProperty(this, "pending", void 0);
    _defineProperty(this, "cleanup", void 0);
    _defineProperty(this, "columnFormats", void 0);
    _defineProperty(this, "getCachedValues", memoize((rawValues, _ref, formatter) => {
      var type = _ref.type,
        name = _ref.name;
      if (type !== undefined && TableUtils.isDateType(type)) {
        return rawValues.map(value => this.dateTimeFormatter.format(value));
      }
      return rawValues.map(value =>
      // Skip formatting for nulls so they don't get converted to ''
      value != null && type != null ? formatter.getFormattedString(value, type, name) : null);
    }, {
      max: 1000
    }));
    _defineProperty(this, "getCachedPanelLinks", memoize((dashboardLinks, panel) => {
      var panelId = LayoutUtils.getIdFromPanel(panel);
      log.debug('getCachedPanelLinks', dashboardLinks, panelId);
      return dashboardLinks.filter(link => {
        var _link$end;
        return ((_link$end = link.end) === null || _link$end === void 0 ? void 0 : _link$end.panelId) === panelId;
      });
    }, {
      max: 1000
    }));
    _defineProperty(this, "getCachedSource", memoize(links => {
      log.debug('getCachedSource', links);
      var source;
      if (links.length > 0) {
        var _links = _slicedToArray(links, 1),
          link = _links[0];
        source = link.start;
        if (links.length > 1) {
          log.error('Filter has more that one link', links);
        }
      }
      return source;
    }, {
      max: 1000
    }));
    _defineProperty(this, "getCachedSourceTable", memoize((panelTableMap, source) => {
      var _panelTableMap$get;
      log.debug('getCachedSourceTable', panelTableMap, source);
      if (source == null) {
        return null;
      }
      var panelId = source.panelId;
      return (_panelTableMap$get = panelTableMap.get(panelId)) !== null && _panelTableMap$get !== void 0 ? _panelTableMap$get : null;
    }, {
      max: 1000
    }));
    _defineProperty(this, "getCachedSourceColumn", memoize((table, source) => {
      var _table$columns$find;
      log.debug('getCachedSourceColumn', table, source);
      if (table == null || source == null) {
        return null;
      }
      return (_table$columns$find = table.columns.find(_ref2 => {
        var name = _ref2.name,
          type = _ref2.type;
        return name === source.columnName && type === source.columnType;
      })) !== null && _table$columns$find !== void 0 ? _table$columns$find : null;
    }, {
      max: 1000
    }));
    this.handleChange = debounce(this.handleChange.bind(this), DROPDOWN_FILTER_DEBOUNCE);
    this.handleClearAllFilters = this.handleClearAllFilters.bind(this);
    this.handleDisconnect = this.handleDisconnect.bind(this);
    this.handleReconnect = this.handleReconnect.bind(this);
    this.handleColumnSelected = this.handleColumnSelected.bind(this);
    this.handleSourceFilterChange = this.handleSourceFilterChange.bind(this);
    this.handleSourceSortChange = this.handleSourceSortChange.bind(this);
    this.handleSourceSizeChange = this.handleSourceSizeChange.bind(this);
    this.handleSourceMouseEnter = this.handleSourceMouseEnter.bind(this);
    this.handleSourceMouseLeave = this.handleSourceMouseLeave.bind(this);
    this.handleValuesTableUpdate = this.handleValuesTableUpdate.bind(this);
    this.dropdownFilterRef = /*#__PURE__*/React.createRef();
    this.panelContainer = /*#__PURE__*/React.createRef();
    this.pending = new Pending();
    var dh = props.dh,
      panelState = props.panelState,
      settings = props.settings;
    this.columnFormats = FormatterUtils.getColumnFormats(settings);
    // Filter dropdown needs to show and send full timestamp format with nanoseconds
    this.dateTimeFormatter = new DateTimeColumnFormatter(dh, {
      showTimeZone: false,
      showTSeparator: true,
      defaultDateTimeFormatString: "yyyy-MM-dd HH:mm:ss.SSSSSSSSS"
    });
    var _ref3 = panelState !== null && panelState !== void 0 ? panelState : {},
      _ref3$value = _ref3.value,
      _value = _ref3$value === void 0 ? '' : _ref3$value,
      _ref3$isValueShown = _ref3.isValueShown,
      isValueShown = _ref3$isValueShown === void 0 ? false : _ref3$isValueShown,
      _name = _ref3.name,
      _type = _ref3.type,
      timestamp = _ref3.timestamp;
    var column = _name != null && _type != null ? {
      name: _name,
      type: _type
    } : undefined;
    this.state = {
      column,
      formatter: new Formatter(dh, this.columnFormats),
      valuesTable: undefined,
      valuesColumn: undefined,
      sourceSize: 0,
      value: _value,
      timestamp,
      values: [],
      isValueShown,
      wasFlipped: false,
      skipUpdate: false,
      // eslint-disable-next-line react/no-unused-state
      panelState,
      // Dehydrated panel state that can load this panel

      isDisconnected: false,
      isLoading: false,
      isLoaded: false,
      error: null
    };
  }
  componentDidMount() {
    this.updateValuesTable();
    var _this$props = this.props,
      dashboardLinks = _this$props.dashboardLinks,
      panelTableMap = _this$props.panelTableMap;
    var _this$state = this.state,
      column = _this$state.column,
      value = _this$state.value,
      timestamp = _this$state.timestamp;
    var sourceTable = this.getSourceTable(panelTableMap, dashboardLinks);
    if (sourceTable !== null) {
      this.startListeningToSource(sourceTable);
    }
    if (column != null) {
      var name = column.name,
        type = column.type;
      this.sendUpdate(name, type, value, timestamp);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    var _this$props2 = this.props,
      dashboardLinks = _this$props2.dashboardLinks,
      panelTableMap = _this$props2.panelTableMap,
      settings = _this$props2.settings;
    var valuesTable = this.state.valuesTable;
    var source = this.getSource(dashboardLinks);
    var sourceTable = this.getSourceTable(panelTableMap, dashboardLinks);
    var prevSource = this.getSource(prevProps.dashboardLinks);
    var prevSourceTable = this.getSourceTable(prevProps.panelTableMap, prevProps.dashboardLinks);
    if (settings !== prevProps.settings && settings !== undefined) {
      this.updateFormatterSettings(settings);
    }
    if (valuesTable !== prevState.valuesTable && prevState.valuesTable != null) {
      log.debug('Table in state modified, closing the old table.');
      prevState.valuesTable.close();
    }

    // Checking source change in addition to table change
    // in case a different column is selected in the same table
    if (sourceTable !== prevSourceTable || source !== prevSource) {
      this.updateValuesTable();
    }
    if (sourceTable !== prevSourceTable) {
      if (prevSourceTable !== null) {
        this.stopListeningToSource(prevSourceTable);
      }
      if (sourceTable !== null) {
        this.startListeningToSource(sourceTable);
      }
    }
  }
  componentWillUnmount() {
    var _this$props3 = this.props,
      dashboardLinks = _this$props3.dashboardLinks,
      panelTableMap = _this$props3.panelTableMap;
    var valuesTable = this.state.valuesTable;
    var sourceTable = this.getSourceTable(panelTableMap, dashboardLinks);
    this.pending.cancel();
    if (sourceTable !== null) {
      this.stopListeningToSource(sourceTable);
    }
    if (this.cleanup) {
      this.cleanup();
    }
    if (valuesTable != null) {
      valuesTable.close();
    }
  }
  getCoordinateForColumn() {
    var _element$getBoundingC;
    if (this.panelContainer.current == null) {
      return null;
    }
    var element = this.panelContainer.current.querySelector(".".concat(DropdownFilter.SOURCE_BUTTON_CLASS_NAME));
    var rect = (_element$getBoundingC = element === null || element === void 0 ? void 0 : element.getBoundingClientRect()) !== null && _element$getBoundingC !== void 0 ? _element$getBoundingC : null;
    if (rect == null || rect.width <= 0 || rect.height <= 0) {
      return null;
    }
    var x = rect.left + rect.width / 2;
    var y = rect.bottom;
    return [x, y];
  }
  getSettingsErrorMessage() {
    var sourceSize = this.state.sourceSize;
    if (sourceSize > DropdownFilterPanel.MAX_TABLE_SIZE) {
      return "Table too large, must have fewer than ".concat(DropdownFilterPanel.MAX_TABLE_SIZE, " options.");
    }
    return undefined;
  }
  getPanelErrorMessage() {
    var error = this.state.error;
    return error != null ? "".concat(error) : undefined;
  }
  getSource(links) {
    var panelLinks = this.getCachedPanelLinks(links, this);
    return this.getCachedSource(panelLinks);
  }
  getSourceTable(panelTableMap, links) {
    var source = this.getSource(links);
    return this.getCachedSourceTable(panelTableMap, source);
  }
  getValuesColumn(valuesTable, links) {
    var source = this.getSource(links);
    return this.getCachedSourceColumn(valuesTable, source);
  }
  startListeningToSource(sourceTable) {
    var dh = this.props.dh;
    log.debug('startListeningToSource');
    sourceTable.addEventListener(dh.Table.EVENT_FILTERCHANGED, this.handleSourceFilterChange);
    sourceTable.addEventListener(dh.Table.EVENT_SORTCHANGED, this.handleSourceSortChange);
    sourceTable.addEventListener(dh.Table.EVENT_SIZECHANGED, this.handleSourceSizeChange);
    sourceTable.addEventListener(dh.Table.EVENT_DISCONNECT, this.handleDisconnect);
    sourceTable.addEventListener(dh.Table.EVENT_RECONNECT, this.handleReconnect);
  }
  stopListeningToSource(sourceTable) {
    var dh = this.props.dh;
    log.debug('stopListeningToSource');
    sourceTable.removeEventListener(dh.Table.EVENT_FILTERCHANGED, this.handleSourceFilterChange);
    sourceTable.removeEventListener(dh.Table.EVENT_SORTCHANGED, this.handleSourceSortChange);
    sourceTable.removeEventListener(dh.Table.EVENT_SIZECHANGED, this.handleSourceSizeChange);
    sourceTable.removeEventListener(dh.Table.EVENT_DISCONNECT, this.handleDisconnect);
    sourceTable.removeEventListener(dh.Table.EVENT_RECONNECT, this.handleReconnect);
  }
  handleChange(_ref4) {
    var column = _ref4.column,
      _ref4$isValueShown = _ref4.isValueShown,
      isValueShown = _ref4$isValueShown === void 0 ? false : _ref4$isValueShown,
      value = _ref4.value;
    var _ref5 = column !== null && column !== void 0 ? column : {},
      _ref5$name = _ref5.name,
      name = _ref5$name === void 0 ? undefined : _ref5$name,
      _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? undefined : _ref5$type;
    var sendUpdate = true;
    var timestamp = Date.now();
    this.setState(_ref6 => {
      var _ref7;
      var panelState = _ref6.panelState,
        prevTimestamp = _ref6.timestamp,
        wasFlipped = _ref6.wasFlipped,
        skipUpdate = _ref6.skipUpdate;
      // If the user had a value set, and they flip the card over and flip it back without changing any settings, ignore it
      var isFlip = panelState != null && isValueShown !== panelState.isValueShown && name === panelState.name && type === panelState.type && value === panelState.value;
      sendUpdate = (_ref7 = !skipUpdate && isValueShown && (!isFlip || !wasFlipped)) !== null && _ref7 !== void 0 ? _ref7 : false;
      if (!sendUpdate) {
        timestamp = prevTimestamp;
      }
      return {
        panelState: {
          isValueShown,
          name,
          type,
          value,
          timestamp: timestamp !== null && timestamp !== void 0 ? timestamp : undefined
        },
        timestamp,
        wasFlipped: isFlip,
        skipUpdate: false
      };
    }, () => {
      if (sendUpdate) {
        this.sendUpdate(name !== null && name !== void 0 ? name : null, type, value, timestamp);
      }
    });
  }
  handleDisconnect() {
    this.setState({
      error: new Error('Table disconnected'),
      isDisconnected: true,
      isLoading: false
    });
  }
  handleReconnect() {
    this.setState({
      isDisconnected: false,
      error: null
    });
  }
  handleSourceFilterChange() {
    this.applySourceFilters();
  }
  handleSourceSortChange() {
    this.applySourceSorts();
  }
  handleSourceSizeChange(_ref8) {
    var detail = _ref8.detail;
    this.setState({
      sourceSize: detail
    });
  }
  handleColumnSelected() {
    log.debug('handleColumnSelected');
    var glEventHub = this.props.glEventHub;
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    emitLinkPointSelected(glEventHub, panelId, DropdownFilterPanel.SOURCE_COLUMN, {
      type: 'filterSource'
    });
  }
  handleClearAllFilters() {
    var _this$dropdownFilterR;
    (_this$dropdownFilterR = this.dropdownFilterRef) === null || _this$dropdownFilterR === void 0 || (_this$dropdownFilterR = _this$dropdownFilterR.current) === null || _this$dropdownFilterR === void 0 || _this$dropdownFilterR.clearFilter();
  }

  /**
   * Set the filter value, card side, selected column
   * @param state Filter state to set
   * @param sendUpdate Emit filters changed event if true
   */
  setPanelState(state) {
    var _this$dropdownFilterR2;
    var sendUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var dashboardLinks = this.props.dashboardLinks;
    if (this.getSource(dashboardLinks) == null) {
      log.debug('Ignore state update for unlinked filter', state);
      return;
    }
    // Set the skipUpdate flag so the next onChange handler call doesn't emit the FILTERS_CHANGED event
    this.setState({
      skipUpdate: !sendUpdate
    });

    // Changing the inputFilter state via props doesn't quite work because of the delays on manual input changes
    // Setting the ref state directly triggers the onChange handler and updates the panelState
    (_this$dropdownFilterR2 = this.dropdownFilterRef) === null || _this$dropdownFilterR2 === void 0 || (_this$dropdownFilterR2 = _this$dropdownFilterR2.current) === null || _this$dropdownFilterR2 === void 0 || _this$dropdownFilterR2.setFilterState(state);
  }
  sendUpdate(name, type, value, timestamp) {
    var _this$getSource;
    var _this$props4 = this.props,
      dashboardLinks = _this$props4.dashboardLinks,
      glEventHub = _this$props4.glEventHub;
    var sourcePanelId = (_this$getSource = this.getSource(dashboardLinks)) === null || _this$getSource === void 0 ? void 0 : _this$getSource.panelId;
    var excludePanelIds = sourcePanelId == null ? [] : [sourcePanelId];
    log.debug('sendUpdate', {
      name,
      type,
      value,
      timestamp,
      excludePanelIds
    });
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    emitFilterChanged(glEventHub, panelId, name != null && type != null && timestamp != null ? {
      name,
      type,
      value: value != null ? value : '=null',
      timestamp,
      excludePanelIds
    } : null);
  }
  updateValuesTable() {
    var _this$props5 = this.props,
      dashboardLinks = _this$props5.dashboardLinks,
      panelTableMap = _this$props5.panelTableMap;
    var source = this.getSource(dashboardLinks);
    var sourceTable = this.getSourceTable(panelTableMap, dashboardLinks);
    log.debug('updateValuesTable', source, sourceTable);
    this.setState({
      values: [],
      valuesTable: undefined,
      error: null
    });
    if (source == null) {
      log.debug('Filter unlinked.');
      this.setState({
        isLoading: false,
        isLoaded: true,
        isValueShown: false,
        sourceSize: 0
      });
      return;
    }
    this.setState({
      isLoading: true
    });
    if (sourceTable == null) {
      return;
    }
    this.setState({
      isLoaded: false,
      sourceSize: sourceTable.size
    });
    this.pending.add(sourceTable.copy(), resolved => resolved.close()).then(valuesTable => {
      // Loading/loaded will be set when values array is actually populated
      this.updateViewportListener(valuesTable);
      this.setState({
        valuesTable
      });
    }).catch(error => {
      if (PromiseUtils.isCanceled(error)) {
        return;
      }
      log.error(error);
      this.setState({
        isLoading: false,
        error
      });
    });
  }
  applySourceSorts() {
    var _this$props6 = this.props,
      dashboardLinks = _this$props6.dashboardLinks,
      panelTableMap = _this$props6.panelTableMap;
    var valuesTable = this.state.valuesTable;
    var sourceTable = this.getSourceTable(panelTableMap, dashboardLinks);
    log.debug('applySourceSorts', sourceTable === null || sourceTable === void 0 ? void 0 : sourceTable.sort);
    if (valuesTable == null || sourceTable == null) {
      log.debug('Table not initialized');
      return;
    }
    var sorts = [...sourceTable.sort];
    valuesTable.applySort(sorts);
    this.setViewport(valuesTable);
  }
  applySourceFilters() {
    var _this$props7 = this.props,
      dashboardLinks = _this$props7.dashboardLinks,
      panelTableMap = _this$props7.panelTableMap;
    var valuesTable = this.state.valuesTable;
    var sourceTable = this.getSourceTable(panelTableMap, dashboardLinks);
    log.debug('applySourceFilters', sourceTable === null || sourceTable === void 0 ? void 0 : sourceTable.filter);
    if (valuesTable == null || sourceTable == null) {
      log.debug('Table not initialized');
      return;
    }
    var filters = [...sourceTable.filter];
    valuesTable.applyFilter(filters);
    this.setViewport(valuesTable);
  }
  updateViewportListener(valuesTable) {
    var dh = this.props.dh;
    log.debug('updateViewportListener', valuesTable === null || valuesTable === void 0 ? void 0 : valuesTable.size);
    if (this.cleanup) {
      this.cleanup();
    }
    if (valuesTable == null) {
      this.cleanup = undefined;
      return;
    }
    this.cleanup = valuesTable.addEventListener(dh.Table.EVENT_UPDATED, this.handleValuesTableUpdate);
    this.setViewport(valuesTable);
  }
  setViewport(valuesTable) {
    var dashboardLinks = this.props.dashboardLinks;
    var valuesColumn = this.getValuesColumn(valuesTable, dashboardLinks);
    if (!valuesColumn) {
      log.error('values column is null');
      return;
    }
    valuesTable.setViewport(0, DropdownFilterPanel.MAX_TABLE_SIZE - 1, [valuesColumn]);
  }
  updateFormatterSettings(settings) {
    var dh = this.props.dh;
    var columnFormats = FormatterUtils.getColumnFormats(settings);
    if (!deepEqual(this.columnFormats, columnFormats)) {
      this.columnFormats = columnFormats;
      this.setState({
        formatter: new Formatter(dh, columnFormats)
      });
    }
  }
  handleValuesTableUpdate(_ref9) {
    var detail = _ref9.detail;
    var rows = detail.rows;
    var dashboardLinks = this.props.dashboardLinks;
    var valuesTable = this.state.valuesTable;
    if (!valuesTable) {
      log.error('valuesTable is null');
      return;
    }
    var valuesColumn = this.getValuesColumn(valuesTable, dashboardLinks);
    if (!valuesColumn) {
      log.error('Values column not found');
      return;
    }
    var values = rows.map(row => row.get(valuesColumn));
    this.setState({
      values,
      isLoading: false,
      isLoaded: true,
      valuesColumn
    });
  }
  handleSourceMouseEnter() {
    var columnSelectionValidator = this.props.columnSelectionValidator;
    if (!columnSelectionValidator) {
      return;
    }
    columnSelectionValidator(this, DropdownFilterPanel.SOURCE_COLUMN, {
      type: 'filterSource'
    });
  }
  handleSourceMouseLeave() {
    var columnSelectionValidator = this.props.columnSelectionValidator;
    if (!columnSelectionValidator) {
      return;
    }
    columnSelectionValidator(this, undefined, {
      type: 'filterSource'
    });
  }
  render() {
    var _this$props8 = this.props,
      columns = _this$props8.columns,
      dashboardLinks = _this$props8.dashboardLinks,
      disableLinking = _this$props8.disableLinking,
      glContainer = _this$props8.glContainer,
      glEventHub = _this$props8.glEventHub,
      isLinkerActive = _this$props8.isLinkerActive;
    var _this$state2 = this.state,
      column = _this$state2.column,
      formatter = _this$state2.formatter,
      isDisconnected = _this$state2.isDisconnected,
      isValueShown = _this$state2.isValueShown,
      value = _this$state2.value,
      values = _this$state2.values,
      valuesColumn = _this$state2.valuesColumn,
      isLoading = _this$state2.isLoading,
      isLoaded = _this$state2.isLoaded;
    var source = this.getSource(dashboardLinks);
    var settingsErrorMessage = this.getSettingsErrorMessage();
    var panelErrorMessage = this.getPanelErrorMessage();
    var formattedValues = isLoaded && valuesColumn != null ? this.getCachedValues(values, valuesColumn, formatter) : EMPTY_ARRAY;
    return /*#__PURE__*/_jsx(WidgetPanel, {
      errorMessage: panelErrorMessage,
      isLoading: isLoading,
      isLoaded: isLoaded,
      isDisconnected: isDisconnected,
      className: "iris-dropdown-filter-panel",
      componentPanel: this,
      glContainer: glContainer,
      glEventHub: glEventHub,
      onClearAllFilters: this.handleClearAllFilters,
      descriptor: WIDGET_DESCRIPTOR,
      children: /*#__PURE__*/_jsx("div", {
        ref: this.panelContainer,
        className: "dropdown-filter-container h-100 w-100 container",
        children: /*#__PURE__*/_jsx(DropdownFilter, {
          ref: this.dropdownFilterRef,
          column: column,
          columns: columns,
          isValueShown: isValueShown,
          isLinkerActive: isLinkerActive,
          disableLinking: disableLinking,
          isLoaded: isLoaded,
          settingsError: settingsErrorMessage,
          source: source,
          value: value,
          values: formattedValues,
          onChange: this.handleChange,
          onColumnSelected: this.handleColumnSelected,
          onSourceMouseEnter: this.handleSourceMouseEnter,
          onSourceMouseLeave: this.handleSourceMouseLeave
        })
      })
    });
  }
}
_defineProperty(DropdownFilterPanel, "displayName", 'DropdownFilterPanel');
_defineProperty(DropdownFilterPanel, "COMPONENT", 'DropdownFilterPanel');
_defineProperty(DropdownFilterPanel, "MAX_TABLE_SIZE", 256);
_defineProperty(DropdownFilterPanel, "SOURCE_COLUMN", Object.freeze({
  name: 'FilterSource',
  type: null
}));
var ConnectedDropdownFilterPanel = connector(DropdownFilterPanel);
export default ConnectedDropdownFilterPanel;
//# sourceMappingURL=DropdownFilterPanel.js.map